import { config } from '~app/config';

import { ResponseSuccess } from '@breezeventures/scp-client';
import { isHttpError } from '@breezeventures/web-lib-ph-request/errors';
import { makeRequest } from '@breezeventures/web-lib-ph-request/make-request';
import { useMutation } from '@tanstack/react-query';

import {
  CheckImageResponse,
  isPendingError,
  PendingError,
} from './file-upload-api';

export type CheckImageParams = {
  transactionId: string;
  signal?: AbortSignal;
};

export function useCheckImage() {
  return useMutation({
    mutationFn: async ({ transactionId, signal }: CheckImageParams) => {
      try {
        const response = await makeRequest<ResponseSuccess<CheckImageResponse>>(
          {
            url: `${config.apiHost}/kyc/api/v1/kyc/images/check_portrait_status`,
            credentials: 'include',
            cache: false,
            timeout: 60 * 1000,
            payload: { transactionId },
            signal,
          }
        ).then((response) => response.payload);

        if (response.status === 'PENDING') {
          throw new PendingError();
        }
        return response;
      } catch (error) {
        const errorTyped = error as Error;
        if (
          isHttpError(errorTyped) &&
          errorTyped.code === 'TRANSACTION_NOT_FOUND'
        ) {
          throw new PendingError();
        }
        throw error;
      }
    },
    retry: (count, error) => {
      return count < 15 && isPendingError(error);
    },
  });
}
